import * as React from 'react';
import { observer } from 'mobx-react-lite';

import { ExtraQuestionProps } from './BaseQuestion';
import { ResultSingleAnswerQuestionInstance } from '../../model/Question/result-single-answer-question.store';
import { MultipleQuestionResult, MultipleQuestionResultProps } from './MultipleQuestionResult';

export interface SingleQuestionResultProps extends MultipleQuestionResultProps {
  data: ResultSingleAnswerQuestionInstance & ExtraQuestionProps;
}

export const SingleQuestionResult = observer((props: SingleQuestionResultProps) => (
  <MultipleQuestionResult {...props} />
));
